module.exports = __webpack_public_path__ + "static/media/5.8bfa93e9.jpg";